<mat-form-field class="size-sm relative w-full">
  <mat-label>{{ label | translate }}</mat-label>
  <input
    aria-label="Text filter input "
    (keyup)="onInput()"
    [attr.aria-label]="filterPlaceholder"
    [formControl]="filterControl"
    matInput
    type="text" />
  @if (showClearButton$ | async) {
    <mat-icon aria-label="Cancel icon" (click)="clearInput($event)" matSuffix> cancel </mat-icon>
  }
</mat-form-field>
